import { Theme } from '@mui/material';

/** AG Grid Theme parameters (replaces variables since AG Grid v32) */
export const skodaAgThemeParams = (theme: Theme) => ({
  // typography
  fontFamily: theme.direction === 'rtl' ? 'SKODA Next R2L' : 'SKODA Next',
  fontSize: 14,
  iconSize: 17,

  // colors
  backgroundColor: 'transparent',
  foregroundColor: theme.palette.text.primary,
  dataColor: theme.palette.text.primary,
  headerForegroundColor: theme.palette.text.primary,
  headerBackgroundColor: 'transparent',
  subHeaderBackgroundColor: 'transparent',
  subHeaderToolbarBackgroundColor: 'transparent',
  secondaryForegroundColor: theme.palette.onSurface.os500,
  disabledForegroundColor: theme.palette.disabled.tertiary,
  checkboxCheckedColor: theme.palette.brand.primary,
  checkboxIndeterminateColor: theme.palette.brand.primary,

  // rows / hover / borders
  rowHoverColor: theme.palette.surface.primary,
  oddRowBackgroundColor: 'transparent',
  rowBorderColor: theme.palette.surface.secondary,
  selectedRowBackgroundColor: theme.palette.surface.primary,

  // sizing / spacing
  headerFontSize: 14,
  headerFontWeight: 700,
  headerHeight: 54,
  rowHeight: 56,
  paginationPanelHeight: 70,
  cellHorizontalPadding: 16,
  cellVerticalPadding: 4,
  rowVerticalPaddingScale: 0.04,
  borderRadius: 8,

  // header separators
  headerColumnSeparatorColor: theme.palette.surface.secondary,
  headerColumnResizeHandleColor: theme.palette.surface.secondary,
  headerColumnSeparatorDisplay: 'block',
  headerColumnResizeHandleDisplay: 'block',
});
